import apiConfig from '../constants/apiConfig';
import axios from 'axios';
import { AORHierarchyNode } from '../components/MapPage/CorporateViewTabs/AorsTab/utils/schema';
import { selectGroupGuid, useAppSelector } from '../slices/commonSelectors';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateAorQueries } from 'hooks/useAors';

export const useCreateOpfacsFromFile = () => {
  const queryClient = useQueryClient();
  const groupGuid = useAppSelector(selectGroupGuid);
  return useMutation({
    mutationFn: async (file: File) => {
      if (!groupGuid) {
        throw new Error(
          'groupGuid is required to create new OPFACs and associated AORs'
        );
      }

      const formData = new FormData();
      formData.append('opfac_file', file);
      return await axios.post<AORHierarchyNode[]>(
        apiConfig.apiGateway.createOpfacsFromFile(groupGuid),
        formData
      );
    },
    onSuccess: () => {
      void invalidateAorQueries(queryClient, groupGuid);
    },
  });
};
